import React from 'react';
import './DesktopSiteNavItemLoading.scss';

export const DesktopSiteNavItemLoading: React.FC = () => (
  <div className="DesktopSiteNavItemLoading">
    <span>Loading</span>
    <span>Loading</span>
    <span>Loading</span>
    <span>Loading</span>
    <span>Loading</span>
    <span>Loading</span>
  </div>
);
